module.exports = __webpack_public_path__ + "static/FAQ-install1-d37edbc0960542ac8af9bab20d9e641c.jpg";